<template>
  <div :class="widgetData.container" id="location_region_detail">
    <div class="row">
      <div class="col-12 d-flex align-items-center mb-4">
        <BackButton/>
        <h2 class="h1 mb-3 ms-md-3 ms-lg-5">{{ placeLocation.langtitle[activeLocale.code] }}</h2>

      </div>
    </div>
    <div class="row">
      <div class="col-12 col-lg-6">
        <figure class="region-figure pointer mb-0 mb-lg-5">
          <picture>
            <PartsSrcSetImage v-if="placeLocation.hasImage()" :image="placeLocation.getTopImage()" :t_type="'cachew'"
                              :type="'webp'"/>
            <PartsSrcSetImage v-if="placeLocation.hasImage()" :image="placeLocation.getTopImage()" :t_type="'cachew'"
                              :type="'jpeg'"/>

            <img v-if="placeLocation.hasImage()"
                 :src="placeLocation.getTopImage().getTyrionSrc('cachew')"
                 :alt="placeLocation.getTopImage().title" class="img-cover" loading="lazy"
                 :width="placeLocation.getTopImage().seoWidth('cache')" :height="placeLocation.getTopImage().seoHeight('cache')">
            <img v-else src="~/assets/img/blank.jpg" :alt="placeLocation.title" class="img-cover" loading="lazy"
                 width="600" height="337">
          </picture>
        </figure>
      </div>
      <div class="col-12 col-lg-6 mt-5 mt-lg-0">
        <div class="d-flex align-items-center h-100">
          <div id="location_region_detail_map" class="position-relative w-100 h-100 d-flex" ref="svgMapContent">
            <SvgIconMapCZ ref="svgMap" v-if="placeLocation.country && placeLocation.country.code === 'cs'"/>
            <SvgIconMapSK ref="svgMap" v-else/>
            <span v-if="visibleElement !== null" class="map-popover" :style="{left: visibleElement.left + 'px', top: visibleElement.top + 'px'}">
            {{ visibleElement.title }}<br>
            <small>
              <TyIcon icon="ty-map-pointer" class="me-1 icon-color-first" height="1.3rem"/>
              <span>{{ placeLocation.count_of_accommodations }}&nbsp;{{ $t($vysklonujSlovo('ponuk', placeLocation.count_of_accommodations, 'y', '', 'a')) }}</span>
            </small>
          </span>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>


<script setup lang="ts">
import {computed, onMounted, onUnmounted, PropType, ref} from "vue";
import "~/assets/less/location_region_detail.min.css";
import {PageDataHolderFetchedWidget} from "~/lib/interfaces/model/PageDataHolderFetchedWidget";
import BackButton from "~/components/web/parts/backButton.vue";
import SvgIconMapSK from "~/assets/icons/svg/ty-map-region-slovakia.svg";
import SvgIconMapCZ from "~/assets/icons/svg/ty-map-region-czech.svg";
import {useWidget} from "../../../../composables/widget/location";
import PlaceTouristRegion from "~/lib/models/PlaceTouristRegion";
import {useNuxtApp} from "#app";

const props = defineProps({
  widget: Object as PropType<PageDataHolderFetchedWidget>
});

const svgMap = ref(null);
const visibleElement = ref(null);
const {$vysklonujSlovo} = useNuxtApp();

const {widgetData, content, location, activeLocale} = useWidget(props.widget);
const placeLocation = computed<PlaceTouristRegion>(() => location as PlaceTouristRegion);

onMounted(() => {
  setTimeout(() => {
    const mapEl = typeof svgMap.value.$el === 'object' && svgMap.value.$el !== null && 'querySelectorAll' in svgMap.value.$el ? svgMap.value.$el : null;
    const allMapSvgTitles = mapEl ? mapEl.querySelectorAll('[data-title]') : [];
    [].forEach.call(allMapSvgTitles, function(path) {
      path.classList.remove('active');
    })

    const activeMapPathAnchor = mapEl ? mapEl.querySelector('[data-title="' + placeLocation.value.langtitle.sk + '"]') : null;
    if (activeMapPathAnchor) {
      activeMapPathAnchor.classList.add('active');
      visibleElement.value = {title: activeMapPathAnchor.dataset.title};
    }
  }, 300);

});

</script>

